var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _c("h4", [_vm._v("Attribute Review")])
      ]),
      _vm._v(" "),
      _vm.attributes.length === 0
        ? _c(
            "v-card-text",
            { key: "no-attrs-to-review", staticClass: "px-0" },
            [
              _c("p", { staticClass: "mb-0" }, [
                _vm._v("This asset has no attributes to review")
              ])
            ]
          )
        : _c(
            "v-card-text",
            { key: "has-attrs-to-review", staticClass: "px-0" },
            [
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n      Please review the attribute values below and make any desired changes\n    "
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.attributes, function(attr, idx) {
                return _c(
                  "div",
                  { key: idx },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: attr.name,
                        placeholder:
                          "Please enter a value for '" + attr.name + "'",
                        "append-icon": _vm.SbIcons.entity.info,
                        "persistent-hint": "",
                        hint: _vm.changeMessage(attr)
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("updated", "attribute", attr)
                        }
                      },
                      model: {
                        value: attr.newValue,
                        callback: function($$v) {
                          _vm.$set(attr, "newValue", $$v)
                        },
                        expression: "attr.newValue"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }